<template>
  <v-container v-if="this.zamawiajacy" class="page">
<table>
  <thead>
  <tr><td>

<div class="cointainer caption" style="margin-top: 0px; margin-bottom: 10px;">
  <div class="left-cointainer">
    <img height="50" class="mt-1" contain src="/static/img/logo-tutore-small.svg">
  </div>
  <div class="right-cointainer">
    Tutore Poland Sp. z o.o.<br>
    ul. Piotrkowska 157A, 90-440 Łódź<br>
    NIP: 7272812193
  </div>
</div>

  </td></tr>
  </thead>
<tbody>
<tr><td>

<p align="center" style="margin-top:20px;">
    <strong>UMOWA O WSPÓŁPRACĘ {{ shortNrUmowy() }}</strong>
</p>
<p>
    Zawarta w Łodzi pomiędzy:
</p>
<p><strong>Zleceniodawcą:</strong></p>
<p>
  <strong>Tutore Poland Sp. z o.o.</strong>, z siedzibą w Łodzi przy ul. Piotrkowska 157A, 90-440 Łódź, wpisaną do
  Rejestru Przedsiębiorców Krajowego Rejestru Sądowego prowadzonego przez Sąd
  Rejonowy dla Łodzi-Śródmieścia w Łodzi, XX Wydział Krajowego Rejestru Sądowego pod
  nr KRS: 0000670834, NIP: 727-28-12-193, REGON: 366891567, kapitał zakładowy 6 481 900,00 zł, reprezentowaną przez: 
</p>
<p>
  <strong>{{zamawiajacy}}</strong>,
</p>
<p>a</p>

  <strong>Zleceniobiorcą:</strong>
  <br/>
  Imię i nazwisko: {{imieNazwisko}}
  <br/>
  Pesel: {{pesel}}
  <br/>
  Adres: {{zamieszkany}}
  <br/>
  <br/>
  prowadzącą/cym działalność gospodarczą pod firmą:
  <br/>
  Nazwa firmy: {{nazwaFirmy}}
  <br/>
  Siedziba firmy: {{siedzibaFirmy}}
  <br/>
  NIP: {{nip}}
  <br/>
  REGON: {{regon}}
  <br/>
  <br/>
  zwanymi dalej łącznie Stronami, a każda z nich indywidualnie Stroną.
  <br/>
  <br/>

  <ol>
    <li>Przedmiotem niniejszej Umowy jest odpłatne świadczenie przez Zleceniobiorcę na rzecz Zleceniodawcy usług związanych z nauczaniem języka angielskiego na rzecz Klientów Zleceniodawcy.</li>
    <li>Miejsce i czas świadczenia Usług zostaną wskazane przez Zleceniodawcę.</li>
    <li>Z tytułu prawidłowego wykonania przedmiotu umowy Zleceniobiorcy przysługuje wynagrodzenie w wysokości:
    </br>
    <div v-html="usluga"></div>
    </br></li>
    <li>Umowa zostaje zawarta na okres od dnia {{ dataObowiazywaniaUmowy() }} do dnia {{ datakon }} r.</li>
    <li>Szczegółowy opis zasad świadczenia usług nauczania języków obcych stosowanych u Zleceniodawcy stanowi Załącznik nr 1 do niniejszej Umowy.</li>
    <li>Szczegółowe zasady i warunki świadczenia usług/współpracy Stron stanowi Załącznik nr 2 do niniejszej Umowy - Ogólne Warunki Umowy (OWU).</li>
    <li>Strony oświadczają, iż otrzymały i zapoznały się z poniższymi załącznikami do Umowy, które stanowią jej integralną część, a podpisując niniejszą Umowę akceptują ich treśc oraz zobowiązują się do ich przestrzegania:</li>
        <ol type="a">
        <li class="underline">Załącznik nr 1 – Zasady świadczenia usług nauczania języków obcych;</li>
        <li class="underline">Załącznik nr 2 – Ogólne Warunki Umowy;</li>
        <li class="underline">Załącznik nr 3 – Upoważnienie do przetwarzania danych osobowych;</li>
        <li class="underline">Załącznik nr 4 – Kwestionariusz i oświadczenia Zleceniobiorcy.</li>
        </ol>
    <li>Umowa została sporządzona w dwóch jednobrzmiących egzemplarzach, po jednym dla każdej ze Stron.</li>
    </ol>  
    
  <div class="cointainer" style="margin-top: 30px;">
      <div class="left-cointainer">
          <span style="margin-left: 0%;">{{zamawiajacy}}</span><br>
          <span style="margin-left: 0%;">(Podpis Zleceniodawcy)</span>
      </div>
      <div class="right-cointainer">
          {{imieNazwisko}}<br>
          <span style="margin-left: 0%;">(Podpis Zleceniobiorcy)</span>
      </div>
  </div>
  <br><br>
  
  <div style="page-break-before: always;">
    <p><strong>Załącznik nr 1 – ZASADY ŚWIADCZENIA USŁUG NAUCZANIA JĘZYKÓW OBCYCH W RAMACH ZAJĘĆ ETUTOR+</strong></p>
    <p class="p-margin-ten"><strong>I. Postanowienia ogólne:</strong></p>
     <ol>
     <li>Niniejszy załącznik obowiązuje Zleceniobiorcę w przypadku prowadzenia przez niego zajęć indywidualnych nauczania języków obcych on-line (dalej: „Zajęć”) w ramach usługi eTutor+ (dalej: „eTutor+”), które oferowane są przez Zleceniodawcę we współpracy z firmą LangMedia sp. z o. o. – właścicielem platformy dostępnej pod adresem www.etutor.pl (dalej: Platforma eTutor). W niniejszym załączniku określono ramowe warunki, zgodnie z którymi Zleceniobiorca będzie prowadził zajęcia eTutor+ bazujące na metodzie eTutor Flipped Blended Learning®. Usługi zostaną wykonane zgodnie z wymogami i terminami określonymi w Umowie.</li>
    </ol>
  </br>
    <p class="p-margin-ten"><strong>II. Organizacja zajęć:</strong></p>
     <ol>
     <li>W celu umożliwienia prowadzenia zajęć w ramach usługi eTutor+, Zleceniodawca udostępni Zleceniobiorcy indywidualne konto na Platformie eTutor.</li>
     <li>Zleceniobiorca będzie prowadzić zajęcia zgodnie z zadeklarowaną przez siebie dostępnością oraz zgodnie z harmonogramem ustalonym ze Zleceniodawcą napodstawie zapisów kursantów, widocznymi na koncie lektora na stronie Zleceniodawcy.</li>
     <li>Strony dopuszczają zmianę dat i godzin zajęć określonych w harmonogramie wyłącznie za obopólną zgodą.</li>
     <li>Nie później niż na tydzień przed zaplanowanymi zajęciami z danym kursantem lub niezwłocznie po przydzieleniu kursanta, Zleceniobiorca zleci mu na Platformie eTutor temat do zrealizowania oraz prześle niezbędne do przeprowadzenia zajęć materiały.</li>
     <li>Przed przeprowadzeniem zajęć Zleceniobiorca ma obowiązek rzetelnego przygotowania się do zajęć.</li>
     <li>Jeżeli kursant zajęć indywidualnych odwoła nieterminowo zaplanowaną lekcję zgodnie z regulaminem obowiązującym kursanta lub nie pojawi się na zajęciach, Zleceniobiorcy będzie przysługiwało wynagrodzenie za te zajęcia.</li>
     </ol>
    </br>
    <p class="p-margin-ten"><strong>III. Sprawdzanie postępów kursantów:</strong></p>
    <ol>
     <li>Zleceniobiorca zobowiązuje się ustalać z kursantami cele nauki.</li>
     <li>Regularnie w trakcie trwania pakietu zajęć z danym kursantem Zleceniobiorca będzie wykonywać z nim powtórki materiału z poprzednich zajęć, chyba że Zleceniodawca zadecyduje inaczej.</li>
     <li>W sytuacji nieprzygotowania do zajęć ze strony kursanta, Zleceniobiorca pozostaje zobligowany do ich przeprowadzenia zgodnie z konspektem dla danego tematu.</li>
     </br>
     </ol>
    <p class="p-margin-ten"><strong>IV. Obecność na zajęciach:</strong></p>
    <ol>
     <li>Zleceniobiorca zobowiązuje się nie spóźniać na Zajęcia. Jeśli z przyczyn od niego niezależnych jednak to nastąpi, powinien poprowadzić je do godziny uwzględniającej czas z jakim się spóźnił na określone Zajęcia lub wydłużyć o tę różnicę czas kolejnych Zajęć (w zależności od tego jak ustali to z kursantem lub Zleceniodawcą). Informacja o tym powinna zostać przekazana Zleceniodawcy.</li>
     <li>W przypadku niemożności przeprowadzenia Zajęć w terminach określonych w harmonogramie z przyczyn leżących po stronie Zleceniobiorcy zobowiązuje się on do niezwłocznego powiadomienia Zleceniodawcy o zaistniałym fakcie, nie później niż 7 dni przed planowanymi zajęciami. W takim przypadku Zleceniodawca może wyznaczyć osobę, która zastąpi Zleceniobiorcę w wykonaniu zlecenia opisanego w niniejszej umowie.</li>
     <li>W przypadku nagłej niedyspozycji wynikającej z choroby lub złego stanu zdrowia, które wystąpiło nagle, Zleceniobiorca może nie zachować 7-dniowego okresu powiadomienia o niemożności wykonywania zlecenia. Zleceniobiorca zobowiązuje się niezwłocznie, nie później niż 4 godziny po wystąpieniu zdarzenia powiadomić o takiej sytuacji Zleceniodawcę. Odwołanie powinno nastąpić najpóźniej 24 godziny przed określoną harmonogramem lekcją, którą planuje odwołać, tak by Zleceniodawca mógł zorganizować zastępstwo bądź mógł powiadomić o przełożeniu zajęć.</li>
     <li>W przypadku nagłej niedyspozycji wynikającej z choroby lub złego stanu zdrowia, które wystąpiło nagle, Zleceniobiorca potwierdza to, na podstawie e-zwolnienia lekarskiego, które wpłynie na profil Zleceniodawcy w portalu PUE ZUS.</li>
     <li>Zleceniobiorca ma prawo odwołać maksymalnie do 10% organizowanych zajęć w ramach prowadzonego kursu.</li>
     <li>W przypadku niemożności przeprowadzenia przez Zleceniobiorcę zajęć zaplanowanych według harmonogramu i niemożliwości znalezienia zastępstwa przez Zleceniodawcę, Zleceniobiorca zobowiązany jest do przeprowadzenia zajęć w ilości godzin równej nieodbytym zajęciom (tzw. zajęcia odrobieniowe) w innym terminie uzgodnionym pisemnie ze Zleceniodawcą.</li>
     <li>Zleceniobiorca zobowiązuje się przestrzegać dress code’u na prowadzonych zajęciach – dozwolony jest ubiór określany mianem „business casual”.</li>
    </ol>
  </div> 
  <br/>
  <div style="page-break-before: always;">
    <p><strong>Załącznik nr 2 – OGÓLNE WARUNKI UMÓW ZLECENIA NAUCZANIA JĘZYKÓW OBCYCH ZAWIERANYCH PRZEZ TUTORE POLAND SP. Z O. O.</strong></p>
    <p class="p-margin-ten"><strong>I. OGÓLNE POSTANOWIENIA I DEFINICJE</strong></p>
     <ol>
     <li>Niniejszy załącznik określa szczegółowe zasady realizacji Umowy o odpłatne świadczenie przez Zleceniobiorcę usług związanych z nauczaniem języków obcych na rzecz Klientów Zleceniodawcy.</li>
     <li>Usługodawca oświadcza, że usługa eTutor+, w ramach której Zleceniobiorca ma świadczyć usługi na rzecz Zleceniodawcy, dedykowana jest osobom pełnoletnim, w związku z czym Zleceniobiorca świadczący dla Zleceniodawcy wyłącznie usługi związane z prowadzeniem zajęć eTutor+, jest zwolniony z obowiązku dostarczenia dodatkowych dokumentów wynikających ze „Standardów Ochrony Małoletnich obowiązujących w Tutore Poland sp. z o.o.”.</li>
    </ol>
  </br>
    <p class="p-margin-ten"><strong>II. PRZEDMIOT UMOWY</strong></p>
     <ol>
     <li>Przedmiotem umowy jest prowadzenie zajęć nauki języków obcych dla klientów Zleceniodawcy (dalej: „Kursanci”) oraz związane z nimi dokonywanie takich czynności jak:</li>
     <ol type="a">
      <li>rzetelne przygotowanie i prowadzenie zajęć on-line dla wszystkich Kursantów zgodnie z programem edukacyjnym wskazanym przez Zleceniodawcę oraz harmonogramem zajęć;</li>
      <li>rzetelne i systematyczne prowadzenie dokumentacji potwierdzającej realizację zajęć, w szczególności: bieżące prowadzenie dziennika zajęć (uzupełnianie najpóźniej do końca dnia, w którym zajęcia się odbyły bądź były zaplanowane), listy obecności oraz/lub zaznaczanie adekwatnych statusów zajęć w systemie;</li>
      <li>współpraca z osobami wyznaczonymi przez Zleceniodawcę;</li>
      <li>regularnego i niezwłocznego (najpóźniej na koniec każdego dnia roboczego) odczytywania wiadomości wysyłanych przez osoby wyznaczone przez Zleceniodawcę Zleceniobiorcy za pośrednictwem poczty elektronicznej, wiadomości sms lub poprzez komunikatory internetowe i w razie potrzeby jak najszybszego udzielenia odpowiedzi na informacje, w tym szczególnie:</li>
      <ol type="I">
        <li>Przekazywanie niezbędnych informacji dotyczących organizacji i przebiegu zajęć;</li>
      </ol>
      <li>Współpraca z kursantami w tym szczególnie udzielanie niezbędnych informacji dotyczących usługi (np. przekazywanie prac domowych);</li>
      <li>Inne zadania i projekty zlecone przez Zleceniodawcę.</li>
     </ol>
     <li>Obowiązki Zleceniodawcy:</li>
     <ol type="a">
      <li>Udzielenie niezbędnej pomocy do wykonania Przedmiotu Umowy, a także współdziałanie w zakresie niezbędnym dla prawidłowego i terminowego wykonania Umowy,</li>
      <li>Udostępnienie Zleceniobiorcy niezbędnych informacji, narzędzi oraz dostępów do platform niezbędnych do realizacji Przedmiotu Zamówienia, za wyjątkiem sprzętu elektronicznego (komputer wraz z łączem internetowym, sprzęt nagłaśniający itp.), które Zleceniobiorca zobowiązany jest zorganizować na własny koszt</li>
     </ol>
     <li>Obowiązki Zleceniobiorcy:</li>
     <ol type="a">
      <li>Świadczenie Usług z należytą starannością, z zachowaniem lojalności względem Zleceniodawcy, zgodnie z najlepszymi praktykami i standardami dydaktycznymi, przy zachowaniu zasad współczesnej wiedzy i zgodnie z obowiązującymi przepisami prawa, zasadami uczciwej konkurencji i poszanowaniem dobrych obyczajów oraz słusznych interesów Zleceniodawcy,</li>
      <li>Sporządzanie stosownej dokumentacji niezbędnej do świadczenia Usług,</li>
      <li>Sporządzanie i przedstawianie Zleceniodawcy raportu ze świadczenia Usług, zawierającego opis przebiegu ich wykonania, rozliczenia oraz uwagi,</li>
      <li>od dnia otrzymania dostępu do konta lektora w systemie Zleceniodawcy - rejestrowanie swojej niedyspozycyjności lub dyspozycyjności w okresie trwania umowy oraz do jej bieżącego aktualizowania na koncie lektora;</li>
      <li>Dokonanie wszelkich innych czynności, niezbędnych dla zapewnienia odpowiedniego świadczenia Usług, które mogą się pojawić w trakcie realizacji Umowy, bądź zgłaszania swoich uwag do osoby kontaktowej wskazanej przez Zleceniodawcę.</li>
     </ol>
     <li>Zleceniobiorca nie może podzlecać swoich zobowiązań wynikających z Umowy podwykonawcom bez wcześniejszej pisemnej zgody Zleceniodawcy. Jeśli Zleceniodawca wyda taką zgodę, Zleceniobiorca będzie nadal odpowiadać za wypełnienie przez każdego podwykonawcę (lub niewypełnienie) zobowiązań, usług lub funkcji w tym samym zakresie, jak gdyby takie zobowiązania, usługi i funkcje wypełniał osobiście.</li>
     </ol>
    </br>
    <p class="p-margin-ten"><strong>III. WYNAGRODZENIE</strong></p>
    <ol>
     <li>Usługi świadczone przez Zleceniobiorcę na rzecz Zleceniodawcy rozliczane będą za faktycznie zlecone i zrealizowane Usługi. Podstawę rozliczenia Usług stanowić będzie jednostkowa stawka godzinowa określona w Umowie, przeliczana proporcjonalnie do faktycznej długości jednostki zajęć w harmonogramie.</li>
     <li>Za okres rozliczeniowy przyjmuje się jeden miesiąc kalendarzowy. Do ostatniego dnia roboczego rozliczanego miesiąca Zleceniobiorca przedstawi w formie elektronicznej zestawienie godzin do akceptacji Zleceniodawcy, wygenerowane za pomocą narzędzi do ewidencjonowania godzin udostępnionego przez Zleceniodawcę.</li>
     <li>Całkowite miesięczne wynagrodzenie obejmować będzie wynagrodzenie za zakończony miesiąc realizacji Usługi, stanowiące iloczyn wykonanych w miesiącu zajęć i jednostkowej stawki godzinowej określonej w Umowie, z zastrzeżeniem ust. 1 powyżej. W przypadku, gdy Zleceniobiorca będzie osobą fizyczną nie prowadzącą działalności gospodarczej jego wynagrodzenie zostanie pomniejszone o należności z tytułu obowiązków podatkowych i ubezpieczeń społecznych, jakie zobowiązany jest ponieść i odprowadzić Zleceniodawca w związku z Umową.</li>
     </br>
     <li>Wypłata wynagrodzenia za każdy miesiąc wykonywania zlecenia następuje:</li>
     <ol type="a">
      <li>W przypadku Zleceniobiorcy będącego osobą fizyczną: z dołu, 15-tego dnia następnego miesiąca kalendarzowego następującego po miesiącu rozliczenia, w wysokości określonej powyżej, w oparciu o zestawienie, o którym mowa w ust. 2 powyżej, na numer konta bankowego wskazanego przez Zleceniobiorcę,</li>
      <li>W przypadku Zleceniobiorcy prowadzącego działalność gospodarczą: z dołu, w ciągu 14 dni od wystawienia faktury VAT (według terminu wskazanego na fakturze) i przesłania faktury elektronicznej do osoby wyznaczonej. Wynagrodzenie jest płatne przelewem na nr konta bankowego wskazany na fakturze wystawionej przez Zleceniobiorcę i zaakceptowanej przez Zleceniodawcę. Warunkiem wypłaty wynagrodzenia jest wykonanie przedmiotu umowy. Zleceniobiorca oświadcza, że podany na fakturze VAT rachunek bankowy będzie rachunkiem bankowym zgłoszonym do elektronicznego rejestru prowadzonego przez Szefa Krajowej Administracji Skarbowej w ramach tzw. „białej listy podatników” (zwanego dalej „Wykazem”), o którym mowa w ustawie o podatku od towarów i usług. Jeżeli przed realizacją płatności Zleceniodawca poweźmie informację o braku zewidencjonowania rachunku bankowego w Wykazie, Zleceniodawca będzie uprawniony do dokonania zapłaty na rachunek bankowy Zleceniobiorcy wskazany w Wykazie, co będzie stanowić wykonanie zobowiązania Zleceniodawcy.</li>
     </ol>
     <li>Zleceniodawca może za dany miesiąc przyznać Zleceniobiorcy premię uznaniową w wysokości do 15% miesięcznego wynagrodzenia brutto.</li>
     <li>Dodatkowo Zleceniodawca może przyznać dodatkową premię uznaniową za inne cele niezwiązane z Przedmiotem Umowy.</li>
     <li>Premia nie ma charakteru roszczeniowego, zaś jej przyznanie, jak i określenie jej wysokości należy do swobodnego uznania Zleceniodawcy.</li>
     <li>Wyliczenie i wypłata premii następuje w ciągu 15 dni od zakończenia miesięcznego okresu rozliczeniowego.</li>
     <li>Zleceniodawca może obniżyć wynagrodzenie o kwotę do 15% wysokości wynagrodzenia brutto za dany miesiąc, w przypadku stwierdzenia przez Zleceniodawcę niestosowania się Zleceniobiorcy do zapisów zawartych w Umowie, w szczególności:</li>
     <ol type="a">
      <li>nieterminowego sprawdzania list obecności oraz/lub zaznaczania statusów zajęć w systemie,</li>
      <li>niedotrzymywania podanej dyspozycyjności,</li>
      <li>spóźniania się na zajęcia,</li>
      <li>niewywiązywania się z wytycznych dotyczących programu i jakości prowadzonych zajęć edukacyjnych określonych przez Zleceniodawcę.</li>
     </ol>
    </ol>
  </br>
    <p class="p-margin-ten"><strong>IV. TAJEMNICA PRZEDSIĘBIORSTWA</strong></p>
    <ol>
     <li>Zleceniobiorca zobowiązuje się do nieudostępniania osobom trzecim informacji poufnych, tj. warunków zawartej Umowy, dokumentów, specyfikacji itp. otrzymanych w związku z realizacją Umowy (z wyjątkiem sytuacji wymaganych odpowiednimi przepisami prawa). Zleceniobiorca zobowiązuje się do utrzymania w ścisłej tajemnicy wszelkich informacji poufnych dotyczących spraw handlowych, klientów i działalności Zleceniodawcy. Zleceniobiorca zobowiązuje się utrzymywać otrzymane Informacje Poufne w tajemnicy i nie ujawniać ich komukolwiek bez pisemnej zgody Zleceniodawcy.</li>
     <li>Zleceniobiorca, po zakończeniu współpracy Stron, bądź też, przed jej zakończeniem – na każde żądanie Zleceniodawcy - zobowiązany będzie zwrócić Zleceniodawcy w ciągu 3 dni wszelkie Informacje Poufne, wraz z dokumentacją i innymi nośnikami, na których zostały one utrwalone, jak również, kopiami dokumentacji lub nośników zawierających takie Informacje. Zleceniobiorca zobowiązuje się do usunięcia z pamięci komputerów oraz innych urządzeń wszystkich otrzymanych lub wykonanych materiałów w sposób uniemożliwiający ich odtworzenie oraz wykorzystywanie w przyszłości w jakiejkolwiek formie.</li>
     <li>Przekazywanie, udostępnianie, wykorzystywanie lub rozpowszechnianie przez każdą ze Stron w jej działalności publicznej lub zawodowej, a w szczególności różnego rodzaju publikacjach, wywiadach, konferencjach, szkoleniach informacji nie stanowiących tajemnicy przedsiębiorstwa, a dotyczących drugiej Strony, przedsiębiorstwa drugiej Strony oraz osób zatrudnionych przez drugą Stronę wymaga uprzedniej pisemnej zgody tej Strony.</li>
     <li>W przypadku naruszenia przez Zleceniobiorcę postanowień ustępów poprzedzających, w szczególności, poprzez niezgodne z tą umową ujawnienie lub udostępnienie materiałów oraz Informacji Poufnych, Zleceniobiorca zobowiązany będzie do zapłaty na rzecz Zleceniodawcy kary umownej w wysokości 20 000,00 zł (słownie: dwadzieścia tysięcy złotych) za każde takie naruszenie. Kara taka płatna będzie w terminie 14 dni od daty złożenia przez Zleceniodawcę oświadczenia o obciążeniu Zleceniobiorcy karą umową.</li>
     <li>Jeżeli wysokość szkody lub utraconych korzyści Zleceniodawcy wynikających z naruszenia przez Zleceniobiorcę postanowień niniejszej umowy przewyższać będzie wysokość kary umownej wskazanej w ust. 4 powyżej, Zleceniodawca może dochodzić odszkodowania uzupełniającego na zasadach ogólnych wynikających z Kodeksu cywilnego.</li>
     <li>Za naruszenie zasad opisanych w Umowie, Zleceniodawca uznaje także każdorazowe wykorzystanie materiałów dydaktycznych Zleceniodawcy do prywatnych celów Zleceniobiorcy oraz do celów nauczania osób, które nie są Klientami Zleceniodawcy.</li>
     <li>Niezależnie od wygaśnięcia czy rozwiązania niniejszej Umowy, zobowiązania Zleceniobiorcy zachowania w poufności Informacji Poufnych pozostają w mocy przez okres 5 lat.</li>
    </ol>
  </br>
    <p class="p-margin-ten"><strong>V. ZAKAZ KONKURENCJI</strong></p>
    <ol>
      <li>Zleceniobiorca jest zobowiązany do powstrzymania się od podejmowania i wykonywania działalności konkurencyjnej wobec Zleceniodawcy, w czasie obowiązywania niniejszej Umowy - zgodnie z definicją opisaną w niniejszym paragrafie. Zakaz ten nie obejmuje świadczenia usług na rzecz podmiotów z grupy kapitałowej Zleceniodawcy.</li>
      <li>Za działalność konkurencyjną Strony uznają oferowanie lub świadczenie, na jakiejkolwiek podstawie lub formie, usług edukacyjnych analogicznych do usług oferowanych przez Zleceniodawcę, na rzecz klientów Zleceniodawcy, którzy zawarli ze Zleceniodawcą umowę najpóźniej w dniu wygaśnięcia albo rozwiązania niniejszej Umowy.</li>
      <li>Za działalność konkurencyjną uznaje się również:</li>
      <ol type="a">
        <li>świadczenie przez Zleceniobiorcę pracy na rzecz podmiotu prowadzącego działalność konkurencyjną wobec Zleceniodawcy (zgodnie z definicją zawartą w ust. 4 poniżej), w tym świadczenie usług na rzecz takich podmiotów na podstawie jakiejkolwiek innej umowy cywilnoprawnej,</li>
        <li>prowadzenie przez Zleceniobiorcę działalności konkurencyjnej wobec Zleceniodawcy, zgodnie z definicją opisaną w ust. 2, także za pośrednictwem osób trzecich,</li>
        <li>bycie wspólnikiem lub członkiem organów spółki prowadzącej działalność konkurencyjną wobec Zleceniodawcy, zgodnie z definicją opisaną w ust. 4,</li>
        <li>pełnienie funkcji agenta, pełnomocnika lub prokurenta w podmiotach prowadzących działalność konkurencyjną wobec Zleceniodawcy, zgodnie z definicją opisaną w ust. 4.</li>
      </ol>
      <li>Za podmiot prowadzący działalność konkurencyjną wobec Zleceniodawcy uznaje się każdy podmiot, który prowadzi działalność o tożsamym charakterze do działalności prowadzonej przez Zleceniodawcę lub podmioty z jego grupy kapitałowej, wykorzystując te same lub podobne technologie, które nie są ogólnodostępne (tj. nie są powszechnie znane), oraz działa w oparciu o zbliżony model biznesowy do modelu Zleceniodawcy. Konkurencyjność tych podmiotów polega na tym, że oferują one usługi lub produkty edukacyjne, które mogą być bezpośrednią alternatywą dla usług oferowanych przez Zleceniodawcę, lub mają na celu pozyskanie tych samych klientów, korzystając z podobnych technologii i struktur organizacyjnych.</li>
      <li>W przypadku, gdy w czasie obowiązywania niniejszej Umowy klient Zleceniodawcy złoży Zleceniobiorcy propozycję współpracy, Zleceniobiorca zobowiązany jest poinformować klienta o obowiązującym go zakazie konkurencji i odmówić podjęcia współpracy. Zleceniobiorca ma również obowiązek niezwłocznie poinformować Zleceniodawcę o zaistniałej sytuacji.</li>
      <li>W przypadku naruszenia zakazu konkurencji, o którym mowa powyżej, za każdy przypadek naruszenia naliczana będzie przez Zleceniodawcę kara umowna w wysokości 200% ostatniego wynagrodzenia brutto otrzymanego przez Zleceniobiorcę.</li>
      <li>Zleceniodawca uprawniony jest do potrącenia z wynagrodzenia umownego Zleceniobiorcy kary umownej.</li>
      <li>Zleceniodawca zastrzega sobie prawo do dochodzenia odszkodowania przewyższającego wysokość zastrzeżonej kary umownej, do wysokości poniesionej szkody.</li>
    </ol>
  </br>
    <p class="p-margin-ten"><strong>VI. DANE OSOBOWE</strong></p>
    <ol>
      <li>Zleceniobiorca, będąc osobą upoważnioną przez Zleceniodawcę do przetwarzania danych osobowych w zakresie wskazanym w pisemnym upoważnieniu, zobowiązany jest do stosowania się do przepisów Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (dalej: RODO) oraz Ustawy z dnia 10 maja 2018 r. o ochronie danych osobowych (t.j. Dz. U. z 2019 r. poz. 1781 z późn. zm).</li>
      <li>Zleceniodawca informuje, iż w celach: zapewnienia materiału dowodowego w sytuacjach spornych z klientem, zapewnienia najwyższych standardów prowadzenia zajęć, weryfikacji prawidłowości prowadzenia zajęć, a w przypadku szkoleń wewnętrznych on-line w celu zapewnienia możliwości udostępnienia nagrań nowym pracownikom/zleceniobiorcom, Zlecedniodawca, tj. Tutore Poland sp. z o. o., korzysta ze środków technicznych umożliwiających nagrywanie (monitoring) prowadzonych zajęć on-line oraz szkoleń wewnętrznych on-line. Monitoringiem są objęte urządzenia rejestrujące obraz oraz dźwięk, z których korzysta w celu realizacji powyższych działań on-line tj. platforma Clickmeeting bądź aplikacja Zoom.</li>
      <li>W związku z powyższym Zleceniodawca informuje, że:</li>
      <ol type="a">
        <li>system monitoringu audiowizualnego i dźwiękowego spotkań online składa się z systemu rejestrującego platformy Clickmeeting bądź Zoom oraz serwera, na którym są zapisywane zajęcia online;</li>
        <li>dostęp do zapisu nagrań zajęć online posiadają osoby upoważnione przez Zarząd Zleceniodawcy, które są świadome odpowiedzialności za ochronę danych osobowych oraz posiadają stosowne upoważnienie wydane przez Administratora danych osobowych.</li>
        <li>w toku nagrania dochodzi do przetwarzania danych osobowych w postaci głosu, wizerunku oraz imienia i nazwiska pracownika/zleceniobiorcy prowadzącego zajęcia lub obecnego na szkoleniu.</li>
      </ol>
      <li>Administratorem danych osobowych Zleceniobiorcy jest Tutore Poland Sp. z o. o., a szczegółowa treść klauzuli informacyjnej dostępna jest pod adresem: https://drive.google.com/file/d/1EvhOzHpkOJ_69DoSI1m6kKh9owwo_RA_/view?usp=sharing</li>
    </ol>
  </br>
    <p class="p-margin-ten"><strong>VII. OKRES OBOWIĄZYWANIA UMOWY, WYPOWIEDZENIE</strong></p>
    <ol>
      <li>Umowa zawarta jest na czas w niej podany.</li>
      <li>Z zastrzeżeniem ust. 5 poniżej, Strony mogą rozwiązać umowę z zachowaniem miesięcznego okresu wypowiedzenia, ze skutkiem na koniec następnego miesiąca kalendarzowego, po pisemnym przesłaniu informacji o wypowiedzeniu umowy.</li>
      <li>Zleceniodawca ma prawo rozwiązać niniejszą umowę bez zachowania okresu wypowiedzenia w przypadku:</li>
      <ol type="a">
        <li>braku możliwości powierzenia Zleceniobiorcy przedmiotu umowy,</li>
        <li>naruszania przez Zleceniobiorcę postanowień niniejszej Umowy, przez co Strony rozumieją w szczególności:</li>
        <ol type="i">
          <li>zachowanie Zleceniobiorcy polegające na niewykonywaniu obowiązków określonych w Umowie, pomimo uprzedniego wezwania ze strony Zleceniodawcy do zaniechania naruszeń,</li>
          <li>złamanie przez Zleceniobiorcę zakazu konkurencji,</li>
          <li>ujawnienie przez Zleceniobiorcę Informacji Poufnych,</li>
          <li>wszelkie inne naruszenia niniejszej umowy.</li>
        </ol>
      </ol>
      <li>W przypadku rozwiązania umowy Zleceniobiorca zobowiązuje się do zwrotu materiałów udostępnionych na czas trwania umowy przez Zleceniodawcę w terminie do 14 dni od dnia rozwiązania lub wygaśnięcia umowy. W przypadku braku zwrotu materiałów w wyznaczonym terminie Zleceniodawca może nałożyć na Zleceniobiorcę karę finansową o wartości otrzymanych materiałów. Dodatkowo Zleceniobiorca może zostać obciążony kosztami przesyłki.</li>
      <li>W przypadku nieprzeprowadzenia zajęć w terminie wynikającym z harmonogramu i niepowiadomienia o tym fakcie Zleceniodawcy z wyprzedzeniem nie mniejszym niż 7 dni przed planowanymi zajęciami, Zleceniodawca może rozwiązać umowę ze skutkiem natychmiastowym bez zachowania okresu wypowiedzenia. Powyższy zapis nie dotyczy sytuacji losowych uniemożliwiających powiadomienie Zleceniodawcy o niemożliwości przeprowadzenia zajęć.</li>
    </ol>
  </br>
    <p class="p-margin-ten"><strong>VIII. POSTANOWIENIA KOŃCOWE</strong></p>
    <ol>
      <li>Strony postanawiają, że o ile nie dojdzie do pisemnego powiadomienia o zmianie adresu do korespondencji wszelka korespondencja kierowana na adresy podane w oznaczeniu stron, uważa się za doręczone najpóźniej z datą drugiego awizo.</li>
      <li>Adresy poczty elektronicznej podane są w oznaczeniu stron. Pismo wysłane drogą elektroniczną uważa się za doręczone z chwilą, gdy druga strona miała możliwość zapoznania się z nim.</li>
      <li>Strony oświadczają, że dołożą wszelkich starań by spory wynikłe z niniejszej umowy rozwiązać polubownie. W przypadku sporów, które nie będą mogły zostać rozwiązane polubownie w ciągu 14 dni od daty otrzymania przez drugą stronę pisemnego wezwania do takiego polubownego rozwiązania, zostaną one poddane pod rozstrzygnięcie sądowi właściwemu ze względu na siedzibę Zleceniodawcy.</li>
      <li>Niniejsza umowa rozwiązuje i zastępuje wszelkie inne dotychczasowe pisemne lub ustne ustalenia, porozumienia, uzgodnienia i umowy Stron w zakresie objętym jej treścią, które niniejszym tracą moc prawną.</li>
      <li>Strony oświadczają, że poza niniejszą umową nie istnieją między nimi żadne dodatkowe ustalenia czy porozumienia dotyczące przedmiotu niniejszej umowy.</li>
      <li>Wszelkie zmiany niniejszej umowy wymagają formy pisemnej pod rygorem nieważności.</li>
      <li>Rozwiązanie niniejszej umowy wymaga formy pisemnej pod rygorem nieważności.</li>
      <li>Niniejsza umowa podlega prawu polskiemu.</li>
      <li>W sprawach nieuregulowanych niniejszą umową zastosowanie mają właściwe przepisy prawa, w szczególności przepisy Kodeksu cywilnego.</li>
    </ol>
  </div>
  <br/>
  <div style="page-break-before: always;">
    <p><strong>Załącznik nr 3 – UPOWAŻNIENIE DO PRZETWARZANIA DANYCH OSOBOWYCH</strong></p>

  <div class="cointainer" style="margin-top: 30px;">
    <div class="left-cointainer">
    </div>
    <div class="right-cointainer">
          <br>
          <span style="margin-left: 0%;">Łódź dn. {{ aktualnaData() }} r.</span>
    </div>
  </div>
  <br/>
  Na podstawie art. 29 Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie danych), dalej RODO, niniejszym: z dniem podpisania upoważnienia przez obie strony upoważniam Pana/Panią {{ imieNazwisko }} - Zleceniobiorcę Tutore Poland sp. z o.o., realizującego umowę zlecenie poprzez prowadzenie zajęć nauczania języków obcych on-line, do przetwarzania danych osobowych zawartych w poniżej wymienionych zbiorach danych osobowych:
     <ol>
     <li>w wersji elektronicznej:</li>
     <ol type="a">
      <li>zbiór danych osobowych Klientów korzystających z usług oferowanych przez Tutore Poland – imię i nazwisko, telefon kontaktowy, adres e-mail,</li>
     </ol>
    </ol>
    w zakresie wglądu do danych osobowych objętych wyżej wymienionymi zbiorami.
  </br>
  Niniejsze upoważnienie nie upoważnia do udzielania dalszych upoważnień i wygasa z dniem ustania umowy zlecenia, a ponadto może być w każdym czasie zmienione lub odwołane. Zobowiązuję Pana/Panią do przetwarzania danych osobowych zawartych w ww. zbiorach danych osobowych w zakresie i w sposób wymagany do wypełnienia obowiązków służbowych względem Zleceniodawcy - Administratora Danych Osobowych. Zobowiązuję Pana/Panią do przetwarzania danych osobowych zgodnie z udzielonym upoważnieniem, RODO oraz przepisami ustawy z dnia 10 maja 2018 r. o ochronie danych osobowych (Dz.U. z 2018 r. poz.1000) i obowiązującymi w Tutore Poland sp. z o.o. wewnętrznymi regulacjami w sprawie ochrony danych osobowych. Naruszenie ww. obowiązków może skutkować poniesieniem odpowiedzialności karnej oraz stanowi podstawę do rozwiązania umowy zlecenie. 
  <br/>
  <div class="cointainer" style="margin-top: 30px;">
      <div class="left-cointainer">
      </div>
      <div class="right-cointainer">
          <br>
          <span style="margin-left: 0%;"><b>{{zamawiajacy}}</b> 
            <br> w imieniu Administartora</span>
      </div>
  </div>
  <br><br>
</div>
<div class="container" style="page-break-before: always;">
      <table style="border: 1px solid; text-align: left; font-size: 12px; width: 100%;">
        <tr>
          <td id="oswiadczenie">
            <p align="center" class="subheading"><strong>OŚWIADCZENIE ZLECENIOBIORCY</strong></p>
            <ol>
          <li>Ja niżej podpisany/a oświadczam, iż:</li>
          <ol type="a">
            <li>zapoznałem/am się z treścią i zakresem upoważnienia i przyjmuję je do wiadomości,</li>
            <li>treść upoważnienia jest dla mnie zrozumiała i jasna, a wszelkie wątpliwości zostały mi wyjaśnione przez osobę upoważnioną w sposób wyczerpujący,</li>
            <li>zobowiązuję się do przetwarzania danych osobowych zawartych w ww. zbiorach danych osobowych w zakresie i w sposób wymagany do wypełnienia obowiązków służbowych względem Zleceniodawcy,</li>
            <li>zobowiązuję się do przetwarzania danych osobowych zgodnie z udzielonym upoważnieniem, przepisami RODO oraz wewnętrznymi procedurami obowiązującymi u Zleceniodawcy, w tym Polityką Prywatności,</li>
            <li>zobowiązuję się do zachowania w tajemnicy danych osobowych, do których mam lub będę miał dostęp w związku z wykonywaniem obowiązków na rzecz Tutore Poland sp. z o.o. oraz zachowania w tajemnicy sposobów zabezpieczenia danych osobowych, również po odwołaniu lub zmianie upoważnienia, a także po zakończeniu trwania umowy zlecenie.</li>
          </ol>
          </ol>
          <div class="right-cointainer" style="float: right; margin-top: 20px;">
          <span style="font-size: 14px;">{{imieNazwisko}}</span>
          <br>
          <span>czytelny podpis Zleceniobiorcy</span>
          </div>
        </td>
      </tr>
    </table>
    Niniejsze upoważnienie uchylone zostało w dniu rozwiązania umowy zlecenie.
</div>
  </br>  

<div style="margin-top:5px;page-break-before: always;">
  <p><em>Załącznik nr 4 – KWESTIONARIUSZ I OŚWIADCZENIA ZLECENIOBIORCY</em></p>
  <p align="center" class="subheading"><strong>Oświadczenie Zleceniobiorcy</strong></p>

  <table style="border: 1px solid; text-align: left; font-size: 12px; width: 100%;">
  <tbody>

  <tr>
  <td style="border: 1px solid; background-color: #a4c2f4; text-align: center; width: 300px;">
  <p class="cell-in-first-table"><span><strong>DANE OSOBOWE</strong></span></p>
  </td>
  <td style="border: 1px solid; background-color: #a4c2f4; text-align: center;">
  <p class="cell-in-first-table"><span><strong>DO WYPEŁNIENIA</strong></span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Data</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{data}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Imiona i Nazwisko</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{imieNazwisko}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Numer PESEL</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{pesel}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Seria i numer dowodu osobistego (proszę podać w przypadku braku nr PESEL)</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{nrDowodu}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Obywatelstwo</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{obywatelstwo}}</span></p>
  </td>
  </tr>

  <tr v-if="obywatelstwoOIZ">
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Posiadam na terytorium Rzeczypospolitej Polskiej centrum interesów osobistych lub gospodarczych (ośrodek interesów życiowych): </span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{obywatelstwoOIZ}}</span></p>
  </td>
  </tr>

  <tr v-if="obywatelstwoDNI">
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Przebywam na terytorium Rzeczypospolitej Polskiej dłużej niż 183 dni w roku kalendarzowym (podatkowym):</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{obywatelstwoDNI}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Numer telefonu</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{nrTelefonu}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Adres e-mail</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{email}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Adres zamieszkania</span><br><span class="caption"> (ulica, nr domu, kod pocztowy, miejscowość)</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table bigCell"><span>{{zamieszkany}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Adres korespondencyjny</span><br><span class="caption"> (ulica, nr domu, kod pocztowy, miejscowość)</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{korespondencyjny}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Urząd Skarbowy <br>(zgodny z adresem zamieszkania)</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table bigCell"><span>{{urzadSkarbowy}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Numer rachunku bankowego</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{nrRachunku}}</span></p>
  </td>
  </tr>

  <tr>
  <td colspan="2" style="border: 1px solid; background-color: #a4c2f4; text-align: center; font-size: 10px">
  <p class="cell-in-first-table"><span><strong>
  Wypełnienie powyższego oświadczenia oznacza deklarację zgodności wypisanych danych ze stanem prawnym oraz faktycznym,oraz świadomość odpowiedzialności karnej za zeznanie nieprawdy lub zatajenie prawdy.
  <br/>
  Zobowiązuję się do poinformowania Pracodawcy w przypadku zmiany ww. danych w terminie 7 dni od daty zaistnienia zmiany. Wyrażam zgodę na podanie Administratorowi danych osobowych mojego numeru telefonu, adresu e-mail i adresu do korespondencji w Oświadczeniu Zleceniobiorcy, celem wysyłki rocznych deklaracji rozliczeniowych.
  <br/>
  </strong></span></p>
  </td>
  </tr>
  </tbody>
  </table>
</div>



<div class="container" style="page-break-before: always;">
      <table style="border: 1px solid; text-align: left; font-size: 12px; width: 100%;">
        <tr>
          <td id="oswiadczenie">
            <p align="center" class="subheading"><strong>OŚWIADCZENIE ZLECENIOBIORCY</strong></p>
            <ol>
          <li>Ja niżej podpisany/a oświadczam, iż:</li>
          <ol type="a">
            <li>zapoznałem/am się z zawartą w Ogólnych Warunkach Umowy Informacją o monitoringu zajęć on-line i nagrywaniu szkoleń wewnętrznych on-line (dalej: „Informacja”) oraz Klauzulą informacyjną i przyjmuję je do wiadomości,</li>
            <li>treść Informacji i Klauzuli jest dla mnie zrozumiała i jasna, a wszelkie wątpliwości zostały mi wyjaśnione przez osobę upoważnioną w sposób wyczerpujący.</li>
          </ol>
          <li>W sposób całkowicie dobrowolny, wyrażam zgodę na przetwarzanie moich danych osobowych w celach wskazanych w Informacji o monitoringu zajęć on-line i nagrywaniu szkoleń wewnętrznych on-line.</li>
          <li>Zostałem/am poinformowany/a, że moje dane osobowe przetwarzane są na podstawie wyrażonej przeze mnie zgody oraz, że przysługuje mi prawo do jej cofnięcia w każdym czasie, przy czym cofnięcie zgody wywołuje skutki prawne od momentu jego złożenia i będzie pozostawało bez wpływu na przetwarzanie moich danych osobowych dla celów związanych z realizacją badania przed złożeniem oświadczenia o cofnięciu zgody.</li>
          <li>W trybie art. 81 ust.1 ustawy o prawie autorskim i prawach pokrewnych wyrażam zgodę na rozpowszechnianie mojego wizerunku przez Tutore Poland Sp. z o.o. w celach wskazanych w Informacji o monitoringu zajęć on-line i nagrywaniu szkoleń wewnętrznych on-line.</li>
          </ol>
          <div class="right-cointainer" style="float: right; margin-top: 20px;">
          <span style="font-size: 14px;">{{imieNazwisko}}</span>
          <br>
          <span>czytelny podpis Zleceniobiorcy</span>
          </div>
        </td>
      </tr>
    </table>
  </br>

    
      <table style="border: 1px solid; text-align: left; font-size: 12px; width: 100%;">
        <tr>
          <td id="oswiadczenie">
            <p align="center" class="subheading"><strong>OŚWIADCZENIE ZLECENIOBIORCY</strong></p>
            Niniejszym oświadczam, że udzielam Tutore Poland sp. z o.o., NIP: 727-28-12-193 (dalej: Zleceniodawca) zgody na nieodpłatne utrwalenie oraz nieograniczone czasowo i terytorialnie, wielokrotne wykorzystanie i rozpowszechnianie mojego wizerunku w formie fotografii w związku z wykonywaniem przeze mnie umowy zlecenia. Wizerunek będzie wykorzystywany wyłącznie na czas trwania umowy w formie zdjęcia w utworzonym dla mnie profilu na platformie Zleceniodawcy, w celu uzupełnienia tego profilu i umożliwienia zapoznania się z nim przez klienta Zleceniodawcy.
          </br>
          Niniejsza zgoda obejmuje następujące pola eksploatacji: wykorzystanie, utrwalanie, obróbkę i powielanie udostępnionych przeze mnie zdjęć, obrót egzemplarzami, na których utrwalono mój wizerunek oraz na zwielokrotnianie wizerunku wszelkimi dostępnymi technikami i metodami, rozpowszechnianie oraz publikowanie, w materiałach służących działalności Zleceniodawcy, w szczególności w materiałach szkoleniowych, edukacyjnych i promocyjnych w dowolnej formie.
          </br>
          Zleceniodawcy przysługuje wyłączne prawo decydowania o formie i czasie wykorzystywania mojego wizerunku. Wizerunek może być użyty do różnego rodzaju form elektronicznego przetwarzania obrazu, kadrowania i kompozycji, bez obowiązku akceptacji produktu końcowego, lecz nie w formach obraźliwych lub ogólnie uznanych za nieetyczne.
          </br>
          <div class="right-cointainer" style="float: right; margin-top: 20px;">
          <span style="font-size: 14px;">{{imieNazwisko}}</span>
          <br>
          <span>czytelny podpis Zleceniobiorcy</span>
          </div>
      </td>
    </tr>
  </table>
  </div>
  </td></tr>
  </tbody></table>

  </v-container>
</template>

<script>
export default {
  name: 'UmowaB2BNauczyciel2025eTutorPlus',
  data () {
    return {
      zamawiajacy: '',
      imieNazwisko: '',
      zamieszkany: '',
      korespondencyjny: '',
      pesel: '',
      nrRachunku: '',
      nrDowodu: '',
      nrTelefonu: '',
      email: '',
      emeryt: '',
      rencista: '',
      orzeczenieNiepelnosprawnosc: '',
      stopienNiepelnosprawnosc: '',
      student: '',
      jedenyTytulDoUbezpieczenia: '',
      chorobowe: '',
      zatrudnionyUmowaPraca: '',
      nazwaUmowaPraca: '',
      umowaOd: '',
      umowaDo: '',
      urzadSkarbowy: '',
      nrUmowy: '',
      datapocz: '',
      datakon: '',
      kwota: '',
      wypo: '',
      slownie: '',
      kwotapokaz: '',
      slowniepokaz: '',
      shortUmowa: '',
      obywatelstwo: '',
      usluga: '',
      nazwaFirmy: '',
      siedzibaFirmy: '',
      nip: '',
      regon: '',
      obywatelstwoOIZ: '',
      obywatelstwoDNI: '',
    };
  },
  created () {
    Object.entries(this.$route.query).forEach(
      ([key, value]) => { this[key] = value }
    )
  },
  methods: {
    shortNrUmowy () {
    let tab = []
    tab = this.nrumowy.split('/')
    this.shortUmowa = `${tab[0]}/${tab[1]}/${tab[2]}/Naucz`
    return this.shortUmowa
  },
    dataObowiazywaniaUmowy () {
      if (this.umowaOd === '' || this.umowaOd === '30-12-1899') {
        return 'podpisania umowy przez obie strony'
      } else {
        return `${this.umowaOd} r.`
      }
    },
    
  aktualnaData() {
  const today = new Date();
  let day = today.getDate();
  if(day <= 9) {
    day = '0' + day;
  }
  let month = today.getMonth() + 1;
  if(month <= 9) {
    month = '0' + month;
  }
  return `${day}-${month}-${today.getFullYear()}`;
}
},
  mounted () {
    if (this.zamawiajacy) {
      this.$nextTick(() => {
        window.setTimeout(() => {
          const currentURL = window.location.href
          history.replaceState(history.state, '', '/')
          window.print()
          history.replaceState(history.state, '', currentURL)
        }, 300)
      })
    }
  }
}
</script>

<style scoped>

.page {
size: 210mm 297mm;
background-size: 100% 100%;
line-height: 1.4;
text-align: justify;
margin-top: 2px;
padding-top: 0px;
}

table {
border: 1px;
border-collapse: collapse;
table-layout: fixed;
}

th, td {
border: 1px;
border-collapse: collapse;
}

.cointainer {
width: 100%;
display: flex;
justify-content: space-between;
}

.cointainer-left {
width: 20%;
}

.right-cointainer {
text-align: end;
}

thead {
display: table-header-group;
}

.table-border {
border: 1px solid black;
border-collapse: collapse;
padding: 5px;
}

.cell-in-first-table {
margin-top: 2px;
margin-bottom: 2px;
margin-left: 10px;
margin-right: 10px;
}

ul.dashed {
list-style-type: "- ";
margin: 0;
}

.underline {
text-decoration: underline;
}

.pageNum {
position: absolute;
right: 0px;
font-size: 14px;
}

#oswiadczenie {
padding: 20px;
}

.p-margin {
margin-bottom: 5px !important;
}

.attachments {
width: 100%;
}

.pelnomocnictwo {
background-image: url('/src/assets/pelnomocnictwo_tutore_male.png');
}

.wage-table {
border: 1px solid; 
font-size: 12px; 
margin: 20px;
width: 50%;
}

.wage-table caption {
text-align: left; 
}

.wage-table td, th {
border: 1px solid #dddddd;
text-align: left;
padding: 8px;
}
</style>




// WEBPACK FOOTER //
// src/components/UmowaB2BNauczyciel2025eTutorPlus.vue